import { Navigate } from 'react-router-dom';
import { useModuleAccess, ModuleType } from '@/hooks/useModuleAccess';
import { Loader2 } from 'lucide-react';

interface ModuleProtectedRouteProps {
  module: ModuleType;
  children: React.ReactNode;
  /**
   * Quando `true`, a rota exige plano pago: se o usuário não tem acesso,
   * é redirecionado para `/planos?module=<module>` (ponto canônico de assinatura).
   *
   * Quando `false` (padrão), free trial é permitido e o gating fica a cargo
   * da página (via `useFreeTrialGate` + `UpgradeWall`). Assim o aluno free
   * entra no módulo escolhido e só vê o paywall ao tentar uma feature paga
   * ou ao estourar a quota gratuita.
   */
  requiresPaidPlan?: boolean;
}

export function ModuleProtectedRoute({ module, children, requiresPaidPlan }: ModuleProtectedRouteProps) {
  const { hasAccess, loading } = useModuleAccess(module);

  if (loading) {
    return (
      <div className="flex min-h-screen items-center justify-center">
        <Loader2 className="h-8 w-8 animate-spin text-primary" />
      </div>
    );
  }

  if (requiresPaidPlan && !hasAccess) {
    return <Navigate to={`/planos?module=${module}`} replace />;
  }

  return <>{children}</>;
}
